module.exports = __webpack_public_path__ + "static/img/2.0e865a9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/18/sp/2.png
// module id = joZi
// module chunks = 0